import { ApiResponse } from "@api/runtime";
import { GLOBALS } from "config";
import { NextResponse } from "next/server";
import Stripe from "stripe";

let stripe: Stripe;
export function getStripeInstance(): Stripe {
  if (!stripe) {
    stripe = new Stripe(process.env.STRIPE_SECRET_KEY as string, {
      apiVersion: GLOBALS.STRIPE_API_VERSION,
    });
  }
  return stripe;
}

//TODOロギング
export function apiErrorResponse(message: string, status: number) {
  return apiErrorResponseJson({ message: message }, status);
}
export function apiErrorResponseJson(data: object, status: number) {
  return NextResponse.json(data, { status: status });
}
export function apiOkResponse(message: string = "ok", status: number = 200) {
  return apiOkResponseJson({ message: message }, status);
}
export function apiOkResponseJson(data: object = { message: "ok" }, status: number = 200) {
  return NextResponse.json(data, { status: status });
}
// responseヘッダをパースして情報を取得する ===================

type ParsedHeaderLink = {
  [rel: string]: {
    url: string;
    page: number;
  };
};

function parseHeaderLink(link: string): ParsedHeaderLink {
  const splittedLink = link.split(",");
  const parsedLink: ParsedHeaderLink = {};
  splittedLink.map((link) => {
    const rel = link.match(/rel="(.+)"/)?.[1];
    const url = link.match(/<(.+)>/)?.[1];
    const page = link.match(/page=([0-9]+)/)?.[1];

    if (!rel || !url || !page) return;

    parsedLink[rel] = { url, page: Number(page) };
  });
  return parsedLink;
}

export function getApiLinkInfo(response: ApiResponse<unknown>) {
  const headerLink = response.raw.headers.get("link") || "";
  const lastPage: number = headerLink ? parseHeaderLink(headerLink).last.page : 0;
  return { lastPage };
}
